export class AppLockModel {
    public constructor(
        public titleText: string,
        public bodyText: string,
    ) {}
}
